import React from 'react';
import { ReviewStar } from '@lux/icons';
import { Preset } from '@lux/text';
import { BrandText } from './rating.styled';
/**
 * For now we show always 5 stars. On manual check,on play store shows 5 stars for rating 4.8
 * If it really required to show half start, will make cutomization later as separate PR.
 */
const StarRating = ({ reviewscount }) => {
    return (React.createElement("div", null,
        React.createElement("span", null, new Array(5).fill(0).map((_, index) => (React.createElement(ReviewStar, { key: index })))),
        React.createElement(BrandText, { preset: Preset.XS },
            " (",
            reviewscount,
            ")")));
};
export default StarRating;
//# sourceMappingURL=index.js.map